// extracted by mini-css-extract-plugin
module.exports = {"componentsTips":"styles_componentsTips__1N6Wc","content":"styles_content__N3Vhi","single":"styles_single__17xC6","tipText":"styles_tipText__1m4vk"};